import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { InternalNavbar, Footer } from "../commonComponents";
import homeBackground from "../../assets/images/Home V2.jpg";
import gameBackground from "../../assets/images/bg-image2.png";
import otherBackground from "../../assets/images/bg-image3.png";
import "./Layout.scss";

const getBackgroundAsset = (pathname) => {
  if (pathname === "/" || pathname === "/insights") {
    return homeBackground;
  }
  if (
    pathname === "/game" ||
    pathname === "/dashboard" ||
    pathname === "/privategame"
  ) {
    return gameBackground;
  }
  return otherBackground;
};

const getBackgroundClass = (pathname) => {
  if (pathname === "/" || pathname === "/insights") {
    return "main-background1";
  }
  if (
    pathname === "/game" ||
    pathname === "/dashboard" ||
    pathname === "/privategame"
  ) {
    return "main-background2";
  }
  return "main-background3";
};

const MainLayout = ({ children }) => {
  const location = useLocation();
  const [backgroundClass, setBackgroundClass] = useState(() => getBackgroundClass(location.pathname));
  const [backgroundImage, setBackgroundImage] = useState(() => getBackgroundAsset(location.pathname));
  const [backgroundLoading, setBackgroundLoading] = useState(true);
  const [backgroundsPreloaded, setBackgroundsPreloaded] = useState(false);
  const [currentChildren, setCurrentChildren] = useState(children);

  useEffect(() => {
    const assets = [homeBackground, gameBackground, otherBackground];
    let active = true;
    let loadedCount = 0;

    assets.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        if (!active) return;
        loadedCount += 1;
        if (loadedCount === assets.length) {
          setBackgroundsPreloaded(true);

          // On first load to /game, keep overlay visible for minimum 300ms
          const minOverlayTime = location.pathname === "/game" ? 300 : 0;
          setTimeout(() => {
            if (active) {
              setBackgroundLoading(false);
            }
          }, minOverlayTime);
        }
      };
    });

    return () => {
      active = false;
    };
  }, [location.pathname]);

  useEffect(() => {
    const targetBackground = getBackgroundAsset(location.pathname);
    const targetClass = getBackgroundClass(location.pathname);

    if (targetBackground === backgroundImage) {
      setBackgroundClass(targetClass);
      return;
    }

    if (backgroundsPreloaded) {
      setBackgroundImage(targetBackground);
      setBackgroundClass(targetClass);
      setBackgroundLoading(false);
      return;
    }

    setBackgroundLoading(true);
    let active = true;
    const img = new Image();
    img.src = targetBackground;
    img.onload = () => {
      if (!active) return;
      setBackgroundImage(targetBackground);
      setBackgroundClass(targetClass);
      setBackgroundLoading(false);
    };

    return () => {
      active = false;
    };
  }, [location.pathname, backgroundImage, backgroundsPreloaded]);

  useEffect(() => {
    if (!backgroundLoading) {
      setCurrentChildren(children);
    }
  }, [children, backgroundLoading]);

  return (
    <div
      className={`white-color ${backgroundClass}`}
      id="scrollToTop"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "100% 100%",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center center",
      }}
    >
      <InternalNavbar />

      {backgroundLoading && (
        <div className="transition-overlay">
          <div className="spinner-container">
            <div className="spinner" />
          </div>
        </div>
      )}

      <div className={`page-content ${backgroundLoading ? "transitioning" : "loaded"}`}>
        {currentChildren}
      </div>

      <Footer />
    </div>
  );
};

export default MainLayout;
